import moment from 'moment';
import Transformer from '../transformer';
import { htmlToMd } from '../../utils/checkout/converter';

export default class OneJobUpdate extends Transformer {
  /**
   * @param JobUpdated
   *
   * @returns {Object} The transformed job udapted
   */
  static send(job) {
    const jobUpdateTransformed = {};
    if (job.slots[0]) {
      if (job.slots[0].date) {
        const date = moment(job.slots[0].date);
        jobUpdateTransformed.date = date.format();
      }

      if (job.slots[0].hourBegin) {
        jobUpdateTransformed.hour_begin = job.slots[0].hourBegin;
      }

      if (job.slots[0].hourEnd) {
        jobUpdateTransformed.hour_end = job.slots[0].hourEnd;
      }

      if (job.slots[0].pauseTime) {
        jobUpdateTransformed.break_time_minutes = job.slots[0].pauseTime;
      }

      if (job.slots[0].lunchType) {
        jobUpdateTransformed.lunch_meal_amount = job.slots[0].lunchType === 'given' ? 0 : (0 + parseFloat(String(job.slots[0].lunchType).replace(',', '.')));
        jobUpdateTransformed.lunch_meal_given_by_customer = job.slots[0].lunchType === 'given';
      }

      if (job.slots[0].pauseType) {
        jobUpdateTransformed.break_time_paid = job.slots[0].pauseType === 'paid';
      }
    }

    if (!job.address.street) {
      job.address.street = '';
    }
    let types = [];
    if (job.addressType === 'home-office') {
      types = ['at_home'];
      jobUpdateTransformed.types = types;
    }

    if (job.contacts && job.contacts.length) {
      job.address.contacts = job.contacts.filter((contact) => contact && contact.id).map((contact) => `/api/v3/contacts/${contact.id}`);
    }

    if (job.access) {
      job.address.comment = job.access;
    }

    jobUpdateTransformed.address = job.address;
    jobUpdateTransformed.jobs = job.selectedEditJobs.map((selectedJob) => selectedJob.job.id);
    jobUpdateTransformed.update_template = job.updateTemplate;
    if (job.tasks && job.tasks.length) {
      jobUpdateTransformed.tasks = job.tasks.map((task) => task.id);
    }

    if (job.jobType) {
      jobUpdateTransformed.category_job = job.jobType.id;
    }

    if (job.additionalOptions && job.additionalOptions.length) {
      jobUpdateTransformed.additional_options = job.additionalOptions.map((option) => option.id);
    }

    if (job.moodOption) {
      jobUpdateTransformed.mood_option = job.moodOption.id;
    }

    if (job.objectifContent) {
      jobUpdateTransformed.description = htmlToMd(job.objectifContent);
    }

    if (job.usefulContent) {
      jobUpdateTransformed.description_other_infos = htmlToMd(job.usefulContent);
    }

    return jobUpdateTransformed;
  }
}
